import { Link, useNavigate } from "react-router-dom";
import { LANGS } from "../lib/routes";
import { useLang } from "../lib/lang";
import { useAlternates } from "../lib/alt";
import { R } from "../lib/routes";

export function targetFor(l, alternates) {
  return alternates.find((a) => a.lang === l)?.path || R.home[l];
}

export const LangSwitcher = ({ light = false, className = "" }) => {
  const { lang } = useLang();
  const { alternates } = useAlternates();
  const navigate = useNavigate();
  return (
    <div className={`flex items-center rounded-full border p-0.5 ${light ? "border-white/25" : "border-[var(--ink)]/15"} ${className}`} role="group" aria-label="Language" data-testid="language-switcher">
      {LANGS.map((l) => (
        <Link
          key={l}
          to={targetFor(l, alternates)}
          hrefLang={l}
          lang={l}
          aria-current={l === lang ? "true" : undefined}
          onClick={(e) => { e.preventDefault(); localStorage.setItem("tl_lang", l); navigate(targetFor(l, alternates)); }}
          data-testid={`lang-switch-${l}`}
          className={`rounded-full px-2.5 py-1 font-mono text-[0.72rem] uppercase tracking-wider transition-colors duration-300 ${l === lang ? (light ? "bg-white text-[var(--ink)]" : "bg-[var(--ink)] text-[var(--paper)]") : light ? "text-white/80 hover:text-white" : "text-[var(--ink)]/70 hover:text-[var(--ink)]"}`}
        >
          {l}
        </Link>
      ))}
    </div>
  );
};
